import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <section className="not-found-section">
        <div className="container">
          <div className="not-found-content">
            <h1 className="not-found-title">404</h1>
            <h2 className="not-found-subtitle">Oops! Page not found</h2>
            <p className="not-found-description">
              Sorry but the page you are looking for could not be found. It might have been deleted,
              renamed, or is temporarily unavailable. You can search the site below, or return to
              the front page.
            </p>
            <div className="not-found-search">
              <input type="text" className="search-input" placeholder="Search..." />
              <button className="search-button">
                <span className="search-icon">🔍</span>
              </button>
            </div>
            <div className="not-found-actions">
              <Link to="/" className="btn btn--primary">
                Return to Homepage
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
